<template>
  <AppContainer class="app-footer-container">
    <footer class="app-footer">
      <nav aria-label="Footer navigation" class="navigation">
        <AppLink
          v-for="navLink in navLinks"
          :key="navLink.id"
          class="f-nav-link"
          :to="navLink.fullUrl"
          @click="onNavLinkClick(navLink)"
        >
          {{ navLink.title }}
        </AppLink>
      </nav>

      <ul v-if="socials.length" class="socials">
        <li v-for="icon in socials" :key="icon.platform" class="social-item">
          <AppSocial :icon="icon" />
        </li>
      </ul>
    </footer>
  </AppContainer>
</template>

<script>
import { sendGaEvent } from '@/helpers/ga/gaSend';
import ExternalLinkClickedGaEvent from '@/helpers/ga/events/ExternalLinkClickedGaEvent';
import AppContainer from '@/components/AppContainer.vue';
import AppLink from '@/components/AppLink.vue';
import AppSocial from '@/components/AppSocial.vue';

export default {
  components: {
    AppLink,
    AppContainer,
    AppSocial,
  },
  props: {
    aosEnabled: {
      type: Boolean,
      default: true,
    },
    navLinks: {
      type: Array,
      default: () => [],
    },
    socials: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onNavLinkClick(link) {
      sendGaEvent(
        new ExternalLinkClickedGaEvent()
          .addPageSection('footer_navigation')
          .addLinkUrl(link.fullUrl)
          .addLinkName(link.title)
          .addLinkType('marketing_site')
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.app-footer-container {
  padding-top: 56px;

  @media (min-width: vars.$tablet-break-point) {
    padding-top: 120px;
  }
}

.app-footer {
  padding: 40px 0;
  border-top: 1px solid vars.$c-gray-cc;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 40px;

  @media (min-width: vars.$tablet-break-point) {
    flex-direction: row;
    gap: 30px;
    padding-bottom: 80px;
  }

  @media (min-width: vars.$desktop-lg-992-break-point) {
    align-items: center;
  }

  .navigation {
    display: flex;
    flex-direction: column;
    row-gap: 24px;
    column-gap: 30px;
    padding-left: 16px;
    line-height: normal;

    @media (min-width: vars.$tablet-break-point) {
      flex-direction: row;
      flex-wrap: wrap;
    }

    @media (min-width: vars.$desktop-lg-992-break-point) {
      column-gap: 40px;
    }

    @media (min-width: vars.$desktop-xl-1200-break-point) {
      padding-left: 40px;
    }
  }

  .f-nav-link {
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 2px;
    color: vars.$c-total-black;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .socials {
    display: flex;
    align-items: center;
    gap: 24px;
    list-style-type: none;
    margin: 0;
    padding-left: 16px;

    @media (min-width: vars.$tablet-break-point) {
      padding-left: 0;
    }

    @media (min-width: vars.$desktop-lg-992-break-point) {
      gap: 36px;
    }
  }

  .social-item {
    width: 30px;
    height: 30px;
  }
}
</style>
